import fetchApi from './fecthApi'

const fetchCarrierTrackingApi = fetchApi('carrier-tracking')

export const find = async (orderId, shipmentId) => fetchCarrierTrackingApi(`${orderId}/${shipmentId}`)
